import { useRouter } from 'next/router';
import { COLLECTION_PAGE_CANONICALS } from 'layout/canonical/collectionPageCanonicals';
import { LOCALES } from 'localization/constants/configEnums';

export const useCanonical = () => {
  const { asPath, locale } = useRouter();
  const path = asPath?.split(/[#?]/)?.[0];
  // Default to self-referencing
  let canonical = `https://www.goat.com${path}`;

  if (locale !== LOCALES.enUS) {
    canonical = `https://www.goat.com/${locale}${path}`;
  }

  // Collection page overrides
  if (COLLECTION_PAGE_CANONICALS[path]) {
    canonical = COLLECTION_PAGE_CANONICALS[path];
  }

  return canonical;
};
